<template>
  <div></div>
</template>

<script>
export default {
  name: 'FacialRec'
}
</script>
